
import type { SVGProps } from 'react';
const SvgMeinSchiffAll = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g clipPath="url(#mein-schiff-all_svg__a)">
      <path
        fill="#263E6A"
        fillRule="evenodd"
        d="M16.122 14.558c-.751.924-1.363 1.869-1.363 1.869H7.853a6.05 6.05 0 0 1-.51-8.314h1.925v.062l.367.599h.568l.572.902h1.11l.208.31.173.158-.233.566-.033.201.968 1.525h4.992s-1.086 1.198-1.838 2.122M12 5.401a6.6 6.6 0 1 0 0 13.2 6.6 6.6 0 0 0 0-13.2"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="mein-schiff-all_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgMeinSchiffAll;
